import { createAsyncThunk } from "@reduxjs/toolkit"
import { Api, ApiMethod } from "../../../../utils/Api"
import { processParams } from "../../../../utils/LazyParamsUtil"
import { Resume } from "../interface"

const endpoint = process.env.REACT_APP_JOB_API_URL
const tenantEndpoint = process.env.REACT_APP_TENANT_API_URL

export const candidateRetrieveTenant = createAsyncThunk('candidate-job/retrieveTenant',
  async (companyCode: string, { rejectWithValue }) =>
    Api(ApiMethod.GET, tenantEndpoint, `candidate/tenant/${companyCode}`, undefined, rejectWithValue)
)

export const candidateRetrieveJobs = createAsyncThunk('candidate-job/retrieveJobs',
  async ({ lazyParams, companyCode }: { lazyParams: any, companyCode: string }, { rejectWithValue }) =>
    Api(ApiMethod.GET, endpoint, 'candidate/jobs/' + companyCode, processParams(lazyParams), rejectWithValue)
)

export const candidateRetrieveJob = createAsyncThunk('candidate-job/retrieveJob',
  async ({ jobId, companyCode }: { jobId: number, companyCode: string }, { rejectWithValue }) =>
    Api(ApiMethod.GET, endpoint, `candidate/jobs/${companyCode}/${jobId}`, undefined, rejectWithValue)
)

export const candidateRetriveResume = createAsyncThunk('candidate-job/retrieveResume',
  async ({token, companyCode }: { token: string, companyCode: string}, { rejectWithValue }) => Api(ApiMethod.GET, endpoint, 'candidate/' + companyCode + '/get-resume', { token }, rejectWithValue)
)

export const candidateUploadResume = createAsyncThunk('candidate-job/uploadResume',
  async ({ resumeData, token, companyCode }: { resumeData: FormData, token: string | null | undefined, companyCode: string }, { rejectWithValue }) =>
    Api(ApiMethod.POST, endpoint, 'candidate/' + companyCode + '/upload-resume' + (token ? '?token=' + token : ''), resumeData, rejectWithValue)
)

export const candidateUpdateResume = createAsyncThunk('candidate-job/updateResume',
  async ({ resume, token, companyCode }: { resume: Resume, token: string, companyCode: string }, { rejectWithValue }) =>
    Api(ApiMethod.PUT, endpoint, 'candidate/' + companyCode + '/update-resume?token=' + token, resume, rejectWithValue)
)